<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>招标书详细信息</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="goBack()">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>

        <div class="bidding-container" style="width: 1100px; margin: 0 auto;padding: 10px;background-color: #f1f1f1">
            <h1 class="main-subtitle">
                <span style="text-align:left">{{callBidDocInfo.title}}</span>
            </h1>
            <div class="bidding-details">
                <div class="form-single">
                    <div class="title">报名截至时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.enrollCloseTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">资格预审时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.openTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">投标截止时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.closeTime}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">公布结果时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.resultPublishTime}}</label>
                    </div>
                </div>

                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>基本信息</span>
                </div>

                <div class="form-single">
                    <div class="title">联系人：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.contactName}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">联系电话：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.contactTel}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">发布时间：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.publishTime}}</label>
                    </div>
                </div>

                <div class="content-caption dashed font18" style="background-color: #fff">
                    <span><span class="color-laber"></span>招标方要求</span>
                </div>
                <div class="form-single">
                    <div class="title">注册资金：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.reqRegCapital == null ? 0 : callBidDocInfo.reqRegCapital}}万元</label>
                    </div>
                </div>

                <div class="form-single">
                    <div class="title">报名费用：</div>
                    <div class="content">
                        <label class="mr20" v-if="callBidDocInfo.enrollFree">免费</label>
                        <label class="mr20" v-else>{{callBidDocInfo.enrollFee}}元</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">成立日期：</div>
                    <div class="content">
                        <label class="mr20">{{callBidDocInfo.foundDate == null ? '当前日期' : callBidDocInfo.foundDate}}之前</label>
                    </div>
                </div>

                <div class="form-single">
                    <div class="title">招标预算：</div>
                    <div class="content">
                        <label v-if="callBidDocInfo.budgetFlag == 0 " class="mr20">无预算</label>
                        <label v-if="callBidDocInfo.budgetFlag == 2 " class="mr20">固定总额{{callBidDocInfo.budgetAmount}}元</label>
                    </div>
                </div>

                <div class="form-single">
                    <div class="title">招标方式：</div>
                    <div class="content">
                        <label v-if="callBidDocInfo.directed == true " class="mr20">定向招标</label>
                        <label v-if="callBidDocInfo.directed == false " class="mr20">公开招标</label>
                    </div>
                </div>

                <div class="form-single">
                    <div class="title">结果描述：</div>
                    <div class="content">
                        <label class="mr20 danger">{{callBidDocInfo.resultDesc == null ? '无' : callBidDocInfo.resultDesc}}</label>
                    </div>
                </div>

                <div>
                    <div class="content-caption dashed bg-white">
                        <span>要求资质类型</span>
                    </div>

                    <table class="custom-tbl">
                        <thead class="head align-left">
                        <tr class="row">
                            <th>招标资质组号</th>
                            <th>招标资质名称</th>
                            <th>招标资质类型</th>
                            <th>是否必须</th>
                        </tr>
                        </thead>
                        <tbody class="body align-left">
                        <tr class="row" v-for="bidQuali in callBidReqQualiList">
                            <td>{{bidQuali.groupNo}}</td>
                            <td class="align-left">{{bidQuali.qualiTypeName}}</td>
                            <td>{{qualiKindList[bidQuali.qualiKind].text}}</td>
                            <td>
                                <div class="table-addr">
                                    <el-radio-group disabled v-model="bidQuali.mandatory">
                                        <el-radio :label=false>否</el-radio>
                                        <el-radio :label=true>是</el-radio>
                                    </el-radio-group>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div>
                    <div class="content-caption dashed bg-white">
                        <span>招标要求的人员资质</span>
                    </div>
                    <table class="custom-tbl">
                        <thead class="head align-left">
                        <tr class="row">
                            <th>资质类型</th>
                            <th>类型名称</th>
                            <th>类型等级（及以上）</th>
                            <th>是否必须</th>
                            <th>要求数量</th>
                        </tr>
                        </thead>
                        <tbody class="body align-left">
                        <tr class="row" v-for="staffQuali in callBidDocInfo.staffQualiList">
                            <td class="align-left">{{staffQuali.name}}</td>
                            <td class="align-left">{{staffQuali.qualiName}}</td>
                            <td>
                                <div class="table-addr">
                                    <span v-if="staffQuali.qualiLevel == 1">一级</span>
                                    <span v-if="staffQuali.qualiLevel == 2">二级</span>
                                    <span v-if="staffQuali.qualiLevel == 3">三级</span>
                                    <span v-if="staffQuali.qualiLevel == 4">四级</span>
                                    <span v-if="staffQuali.qualiLevel == 5">五级</span>
                                </div>
                            </td>
                            <td>
                                <div class="table-addr">
                                    <span v-if="staffQuali.mandatory">是</span>
                                    <span v-else>否</span>
                                </div>
                            </td>
                            <td>{{staffQuali.quantity}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="content-caption dashed font18">
                    <span><span class="color-laber"></span>内容摘要</span>
                </div>
                <div class="form-single">
                    <label class="ml20">{{callBidDocInfo.digest}}</label>
                </div>

                <div v-if="resultFlag && checkedTime">
                    <div class="content-caption dashed font18" style="background-color: #fff" v-if="callBidDocInfo.callBidGoodsList !=null && callBidDocInfo.callBidGoodsList.length>0">
                        <span><span class="color-laber"></span>招标内容</span>
                    </div>
                    <div v-if="callBidDocInfo.callBidGoodsList !=null && callBidDocInfo.callBidGoodsList.length>0">
                        <table class="custom-tbl">
                            <thead class="head">
                            <tr class="row">
                                <th>商品名称</th>
                                <th>数量</th>
                                <th>单位</th>
                                <th>说明</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="callBidGoods in callBidDocInfo.callBidGoodsList">
                                <td>{{callBidGoods.name}}</td>
                                <td>{{callBidGoods.quantity}}</td>
                                <td>{{callBidGoods.unit}}</td>
                                <td>{{callBidGoods.desc}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="content-caption dashed bg-white" v-if="callBidDocInfo.callBidServcList!=null && callBidDocInfo.callBidServcList.length>0">
                        <span>招标内容</span>
                    </div>
                    <div v-if="callBidDocInfo.callBidServcList !=null && callBidDocInfo.callBidServcList.length>0">
                        <table class="custom-tbl">
                            <thead class="head">
                            <tr class="row">
                                <th>名称</th>
                                <th>描述</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="callBidServc in callBidDocInfo.callBidServcList">
                                <td>{{callBidServc.name}}</td>
                                <td>{{callBidServc.desc}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="content-caption dashed bg-white">
                        <span>附件</span>
                    </div>

                    <div class="form-single">
                        <div class="content" style="padding-left: 38px;">
                            <div class="file-area clearfix">
                                <swb-file-item v-for="(file, index) in callBidDocInfo.callBidFileList" :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5"></swb-file-item>
                            </div>
                        </div>
                    </div>

                    <div class="content-caption dashed bg-white">
                        <span>商务条款</span>
                    </div>

                    <swb-create-trade-rule :comparedTradeRuleList="comparedTradeRuleList" :type="type" :operate="operate" :forBid=true :forGoods="forGoods" :forServc="forServc" ref="swb_create_trade_rule"></swb-create-trade-rule>
                </div>


                <div class="tags-status" v-if="!callBidDocInfo.isEnroll && callBidDocInfo.resultFlag==0 && callBidDocInfo.enrollAllowed">
                    <div class="btn-status fl mr10">
                        <button class="swb-btn swb-btn-primary" @click="signUpJudge(callBidDocInfo.id)">立即报名</button>
                    </div>
                </div>
                <div class="tags-status" v-if="resultFlag && checkedTime && !callBidDocInfo.isBid && callBidDocInfo.resultFlag==0 && callBidDocInfo.tendAllowed">
                    <div class="btn-status fl mr10">
                        <button class="swb-btn swb-btn-primary" @click="bidDocJudge(callBidDocInfo.id)">立即投标</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    //
    import callBidApi from '../../api/callBid'
    import tendBidApi from '../../api/tendBid'

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);

    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);

    import SwbSaveBidDoc from './SaveBidDoc';
    Routes.add(SwbSaveBidDoc);

    import SwbBidEnrollSignUp from './BidEnrollSignUp';
    Routes.add(SwbBidEnrollSignUp);

    import SwbBidMarketList from './BidMarketList';
    Routes.add(SwbBidMarketList);

    import SwbOriebteeringCallBidList from './OrienteeringCallBidList.vue';
    Routes.add(SwbOriebteeringCallBidList);

    function sortCallBidReqQuali(itemList) {
        itemList.sort(function (item1, item2) {
            var retValue = item1['groupNo'] - item2['groupNo'];
            if(retValue == 0) {
                retValue = item1['seqNo'] - item2['seqNo']
            }
            return retValue;
        });
        return itemList;
    }

    export default{
        name: 'swb-call-bid-doc-info',
        path: '/call/bid/doc/detail',
        pathOld: '/call/bid/doc/info/to',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '招标书详情',
        data: function () {
            return {
                callBidDocInfo: {},

                qualiKindList: [],
                callBidReqQualiList: [],

                CompanyUnionpayValue: null,
                SWBValue: null,
                offlineValue: null,
                //
                VatSpecialInvoiceValue: null,
                ValueAddedTaxInvoiceValue: null,
                NoneValue: null,
                type: 'callBid',
                operate: 'chakan',
                comparedTradeRuleList: [],
                forGoods: true,
                forServc: true,
                resultFlag: false,
                checkedTime: false,
            }
        },
        created: function () {
            this.resultFlag = this.$route.query.flag;

            this.qualiKindList = getEnumList("qualiKind");

            let openTime = this.$route.query.openTime;
            this.checkedTime = this.checkTime(openTime);

            this.getCallBidDocInfo();
        },
        methods: {

            downloadFile: function (fileDownloadUrl) {
                Utils.downloadFile(getAppUrl(fileDownloadUrl));
            },

            viewImage: function (fileBrowseUrl) {
                Utils.setPageUrl(fileBrowseUrl, '_blank');
            },
            // 获取（零售商）招标书信息
            getCallBidDocInfo: function () {
                let self = this;
                let callDocId = this.$route.query.callBidDocId;
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidDocInfo(callDocId, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let callBidDocInfo = result.data;
                        //转注册资金(为万元)
                        if(typeof callBidDocInfo.reqRegCapital == 'number') {
                            callBidDocInfo.reqRegCapital = (callBidDocInfo.reqRegCapital / 10000).round(4);
                        }

                        let callBidReqQualiList = callBidDocInfo.callBidReqQualiList;
                        if(callBidReqQualiList.length > 0) {
                            callBidReqQualiList = sortCallBidReqQuali(callBidReqQualiList);
                        }
                        self.callBidReqQualiList = callBidReqQualiList;

                        self.callBidDocInfo = callBidDocInfo;

                        self.getTradeRuleInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            syncGroupNo: function (callBidReqQualiList) {
                let groupNoQualiIdsMap = {};
                for(let i = 0; i < callBidReqQualiList.length; i++) {
                    let callBidReqQuali = callBidReqQualiList[i];
                    let groupNo = callBidReqQuali.groupNo;
                    let quliTypeId = callBidReqQuali.qualiTypeId;
                    let qualiTypeIds = groupNoQualiIdsMap[groupNo];
                    if(qualiTypeIds == null) {
                        qualiTypeIds = [];
                        groupNoQualiIdsMap[groupNo] = qualiTypeIds;
                    }
                    qualiTypeIds.push(quliTypeId);
                }
                this.groupNoQualiIdsMap = groupNoQualiIdsMap;
            },

            getTradeRuleInfo: function () {
                let self = this;
                let callDocId = this.$route.query.callBidDocId;
                let postData = {};
                postData.docId = callDocId;
                callBidApi.getCallBidTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let callBidTermList = result.data;
                        if(callBidTermList != null && callBidTermList.length > 0) {
                            self.comparedTradeRuleList = callBidTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },
            // 报名前检查是否已经报名
            signUpJudge: function (callDocId) {
                let self = this;
                tendBidApi.checkBidEnroll(callDocId, function (result) {
                    if(result.type == 'info') {
                        self.toBidEnrollsignUp(callDocId);
                    } else {
                        Toast.show(result.message, 3000, 'warning');
                        return false;
                    }
                });
            },
            toBidEnrollsignUp: function (callDocId) {
                this.$router.push({
                    path: SwbBidEnrollSignUp.path,
                    query: {
                        callDocId: callDocId,
                        // 用于 判断取消操作
                        goindex: 'true',
                        hisUrl: SwbOriebteeringCallBidList.path
                    }
                });
            },

            checkTime: function (time) {
                var currTime = new Date();
                var dbTime = new Date(time);

                if(currTime.getTime() >= dbTime.getTime()) {
                    return true;
                } else if(currTime.getTime() < dbTime.getTime()) {
                    return false;
                }
            },
            // 检查是否已经投标
            bidDocJudge: function (callDocId) {
                let self = this;
                let postData = {};
                postData.callDocId = callDocId;
                tendBidApi.getBidDocCheckResult(postData, function (result) {
                    if(result.type == 'info') {
                        self.toSaveBidDoc(callDocId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 参与投标
            toSaveBidDoc: function (docId) {
                this.$router.push({
                    path: SwbSaveBidDoc.path,
                    query: {
                        callBidDocId: docId
                    }
                });
            },
            goBack: function () {
                let checkState = this.$route.query.checkState;

                this.$router.push({
                    path: SwbOriebteeringCallBidList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidDocInfo.vue